import type { Palette, Typeface } from "@how/website-core";

/** The text colour each palette uses, for the preview. Mirrors the standard theme's `theme.css`, which is the authority. */
export const PALETTE_INK: Record<Palette, string> = {
  quiet: "#17171a",
  warm: "#16130f",
  mono: "#000000",
  dark: "#f2f2f4",
};

/** The families, so the preview is set in the face the church actually chose. */
export const TYPEFACE_STACKS: Record<Typeface, string> = {
  modern: '"Inter Tight", ui-sans-serif, system-ui, sans-serif',
  rounded: '"Plus Jakarta Sans", ui-sans-serif, system-ui, sans-serif',
  editorial: "Archivo, ui-sans-serif, system-ui, sans-serif",
};
